import React from 'react';
import { Section } from './ui/Section';
export function HowItWorks() {
  const steps = [{
    num: '1',
    title: 'Eliges una base el domingo',
    desc: '(Pollo, Carne o Frijol) y la cocinas en 15-20 min mientras escuchas música.'
  }, {
    num: '2',
    title: 'Guardas la base',
    desc: 'Almacenas tu proteína neutra en la nevera, lista para la acción.'
  }, {
    num: '3',
    title: 'Añades el "Giro"',
    desc: 'Cada noche, tomas una porción, añades los 3 ingredientes extra y sirves una cena que parece recién hecha en menos de 10 minutos.'
  }];
  return <Section bg="white" data-id="element-120">
      <h2 className="text-3xl md:text-4xl font-bold text-center mb-12 text-[#422006]" data-id="element-121">
        ¿Cómo funciona?
      </h2>

      <div className="grid md:grid-cols-3 gap-8 relative" data-id="element-122">
        {/* Connecting line for desktop */}
        <div className="hidden md:block absolute top-12 left-[16%] right-[16%] h-0.5 bg-[#F59E0B]/30 z-0" data-id="element-123"></div>

        {steps.map((step, idx) => <div key={idx} className="relative z-10 flex flex-col items-center text-center" data-id="element-124">
            <div className="w-24 h-24 bg-[#FFF8F0] border-4 border-[#F59E0B] rounded-full flex items-center justify-center text-4xl font-black text-[#EA580C] mb-6 shadow-lg" data-id="element-125">
              {step.num}
            </div>
            <h3 className="text-xl font-bold text-[#422006] mb-3" data-id="element-126">
              {step.title}
            </h3>
            <p className="text-[#78350F] leading-relaxed" data-id="element-127">{step.desc}</p>
          </div>)}
      </div>
    </Section>;
}